const Types = {
    VIEW_REQUEST: '@protocolo-visualizar/VIEW_REQUEST',
    VIEW_PROTOCOLO: '@protocolo-visualizar/VIEW_PROTOCOLO',
    CLEAR: '@protocolo-visualizar/CLEAR'    
}

export default Types;